export function triggerDownload(url: string, fileName?: string): void {
  const a = document.createElement('a')
  a.href = url
  if (fileName) {
    a.download = fileName // works for same-origin or blob/object URLs
  }
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
